var render = function (_h,_vm) {var _c=_vm._c;return _c('v-btn',_vm._g(_vm._b({staticClass:"px-3 py-2 btn",class:[_vm.data.class, _vm.data.staticClass, _vm.props.blue ? 'blue' : ''],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"outline":"","round":""}},'v-btn',[_vm.data.attrs],false),_vm.listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }